import colors from "../../theme/Colours";

export const fieldTitleStyle = {
  marginBottom: "8px",
  fontSize: "14px",
  fontWeight: 500,
  fontFamily: "Roboto",
  color: colors.defaultFontColor,
};

export const titleStyle = {
  marginBottom: "8px",
  fontSize: "17.38px",
  fontWeight: 600,
  fontFamily: "Montserrat",
  color: colors.headerTextColor,
  mb: "16px",
  mt: "60px",
};

export const documentLabelStyle = {
  height: "18px",
  my: "8px",
  "& .MuiFormControlLabel-label": {
    fontFamily: "Roboto",
    fontSize: "14px",
    fontWeight: 500,
    color: colors.documentLableColor,
    "&.Mui-disabled ": {
      color: colors.documentDisabled,
    },
  },
  display: "flex",
  alignItems: "center",
};

export const radioIconStyle = {
  display: "flex",
  alignItems: "center",
  fontSize: 16,
  "&.Mui-checked": {
    color: colors.primaryButtonOrange,
  },
};

export const selectedImageDiv = {
  border: `1px solid ${colors.fieldGreyBG}`,
  backgroundColor: colors.fileUploadBG,
  borderRadius: "4px",
  padding: "10px 16px",
  width: "auto",
  height: "36px",
  display: "flex",
  alignItems: "center",
  gap: "8px",
  cursor: "pointer",
  // justifyContent: "space-between",
};

export const uploadButtonContainer = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
};

export const uploadButton = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "92px",
  height: "25px",
  borderRadius: "2px",
  border: `1px solid ${colors.primaryButtonOrange}`,
  color: colors.background2,
  fontFamily: "Roboto",
  fontSize: "14px",
  fontWeight: 400,
  marginRight: "4px",
  backgroundColor: colors.primaryButtonOrange,
  cursor: "pointer",
};

export const checkBox = {
  width: "20px",
  height: "20px",
  borderRadius: "4px",
  border: `2px solid ${colors.primaryButtonOrange}`,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const checkBoxChecked = {
  ...checkBox,
  backgroundColor: colors.primaryButtonOrange,
};

export const iconButtonstyle = {
  padding: 0,
  ml: "auto",
  alignSelf: "flex-start",
  mt: "1px",
};

export const getDropdownCreateButtonStyle = (
  disabled: boolean
): React.CSSProperties => ({
  height: 56,
  padding: "0 16px",
  borderRadius: "4px",
  border: "1px solid",
  borderColor: disabled ? "#bdbdbd" : "#C4C4C4",
  textTransform: "none" as React.CSSProperties["textTransform"],
  justifyContent: "space-between",
});

export const dropdownCreateLabelStyle: React.CSSProperties = {
  fontSize: 14,
  lineHeight: 1,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

export const dropdownCreateMenuStyle: React.CSSProperties = {
  border: "1px solid #e2e8f0",
  borderRadius: 6,
  boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
  maxHeight: 280,
  overflowY: "auto",
};

export const dropdownCreateOptionStyle: React.CSSProperties = {
  padding: "10px 12px",
};
